export default __webpack_public_path__ + "images/LX.925bc7d.png";